/** Hardcoded NTA instructions copy from Figma I2 (node 125:1342). */

export const NTA_PALETTE_ICON = {
  NOT_VISITED: 'not-visited',
  NOT_ANSWERED: 'not-answered',
  ANSWERED: 'answered',
  MARKED_FOR_REVIEW: 'marked-for-review',
  ANSWERED_MARKED: 'answered-marked'
};

export const NTA_PALETTE_LEGEND = [
  {
    key: 'not-visited',
    icon: NTA_PALETTE_ICON.NOT_VISITED,
    text: 'You have not visited the question yet.'
  },
  {
    key: 'not-answered',
    icon: NTA_PALETTE_ICON.NOT_ANSWERED,
    text: 'You have not answered the question.'
  },
  {
    key: 'answered',
    icon: NTA_PALETTE_ICON.ANSWERED,
    text: 'You have answered the question.'
  },
  {
    key: 'marked-for-review',
    icon: NTA_PALETTE_ICON.MARKED_FOR_REVIEW,
    textBeforeBold: 'You have ',
    textBold: 'NOT',
    textAfterBold:
      ' answered the question, but have marked the question for review.'
  },
  {
    key: 'answered-marked',
    icon: NTA_PALETTE_ICON.ANSWERED_MARKED,
    text: 'The question(s) "Answered and Marked for Review" will be considered for evaluation.'
  }
];

export const NTA_GENERAL_INSTRUCTIONS = [
  'Total duration of UGC-NET is 180 minutes (Paper-1 is 60 minutes & Paper-2 is 120 minutes).',
  'The clock will be set at the server. The countdown timer in the top right corner of the screen will display the remaining time available for you to complete the examination. When the timer reaches zero, the examination will end by itself. You will not be required to end or submit your examination.',
  'The Questions Palette displayed on the right side of the screen will show the status of each question using one of the following symbols:',
  'You can click on the ">" arrow which appears to the left of the question palette to collapse the question palette thereby maximising the question window. To view the question palette again, you can click on "<" which appears on the right side of the question window.',
  'You can click on your "Profile" image on the top right corner of your screen to change the language during the exam for the entire question paper. On clicking the Profile image, you will get a drop-down to change the question content to the desired language.',
  'You can click on ⬇️ to navigate to the bottom and ⬆️ to navigate to the top of the question area without scrolling.'
];

export const NTA_QUESTION_NAV_INTRO = 'To answer a question, do the following:';

export const NTA_QUESTION_NAV_ITEMS = [
  'Click on the question number in the Question Palette at the right of your screen to go to that numbered question directly. Note that using this option does NOT save your answer to the current question.',
  'Click on Save & Next to save your answer for the current question and then go to the next question.',
  'Click on Mark for Review & Next to save your answer for the current question, mark it for review, and then go to the next question.'
];

export const NTA_ANSWERING_INTRO =
  'Procedure for answering a multiple-choice type question:';

export const NTA_ANSWERING_SUB_ITEMS = [
  'To select your answer, click on the button of one of the options.',
  'To deselect your chosen answer, click on the button of the chosen option again or click on the Clear Response button.',
  'To change your chosen answer, click on the button of another option.',
  'To save your answer, you MUST click on the Save & Next button.',
  'To mark the question for review, click on the Mark for Review & Next button.'
];

export const NTA_ANSWERING_CHANGE =
  'To change your answer to a question that has already been answered, first select that question for answering and then follow the procedure for answering that type of question';

export const NTA_SECTION_NAV_INSTRUCTIONS = [
  'Sections in this question paper are displayed on the top bar of the screen. Questions in a section can be viewed by clicking on the section name. The section you are currently viewing is highlighted.',
  'After clicking the Save & Next button on the last question for a section, you will automatically be taken to the first question of the next section.',
  'You can shuffle between sections and questions anytime during the examination as per your convenience only during the time stipulated.',
  'Candidate can view the corresponding section summary as part of the legend that appears in every section above the question palette.'
];

export const NTA_INSTRUCTION_SECTIONS = {
  GENERAL: 'General Instructions',
  QUESTION_NAV: 'Navigating to a Question',
  ANSWERING: 'Answering a Question:',
  SECTION_NAV: 'Navigating through sections:'
};
